/* ============================================================
   MT — Scripts propios (vanilla, sin librerias)
   Una funcion init por componente. Todas comprueban si su
   elemento existe antes de hacer nada.
   ============================================================ */

(function () {
  'use strict';

  var sinMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Animaciones de entrada ---- */
  function initReveal() {
    var elementos = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!elementos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add('mt-visible');
        observador.unobserve(entrada.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    elementos.forEach(function (el) { observador.observe(el); });
  }

  /* ---- Cifras que cuentan al entrar en pantalla ---- */
  function initContadores() {
    var nums = document.querySelectorAll('[data-mt-contador]');
    if (!nums.length) return;

    function animar(el) {
      var destino = parseFloat(el.getAttribute('data-mt-contador'));
      if (isNaN(destino)) return;
      var prefijo = el.getAttribute('data-mt-prefijo') || '';
      var sufijo = el.getAttribute('data-mt-sufijo') || '';
      if (sinMovimiento) { el.textContent = prefijo + destino + sufijo; return; }
      var inicio = null;
      var duracion = 1500;
      function paso(t) {
        if (inicio === null) inicio = t;
        var p = Math.min((t - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - p, 3);
        var valor = destino % 1 === 0 ? Math.round(destino * suave) : (destino * suave).toFixed(1);
        el.textContent = prefijo + valor + sufijo;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      nums.forEach(animar);
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        animar(e.target);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.5 });

    nums.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Preguntas frecuentes (acordeon) ---- */
  function initFaq() {
    var items = document.querySelectorAll('.mt-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var boton = item.querySelector('.mt-faq__boton');
      var cuerpo = item.querySelector('.mt-faq__cuerpo');
      if (!boton || !cuerpo) return;

      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-abierto');
        var hermanos = item.parentNode.querySelectorAll('.mt-faq__item');
        hermanos.forEach(function (h) {
          h.classList.remove('mt-abierto');
          var c = h.querySelector('.mt-faq__cuerpo');
          if (c) c.style.maxHeight = null;
          var b = h.querySelector('.mt-faq__boton');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!abierto) {
          item.classList.add('mt-abierto');
          cuerpo.style.maxHeight = cuerpo.scrollHeight + 'px';
          boton.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---- Galeria de la pagina de producto ---- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-principal]');
      var minis = galeria.querySelectorAll('[data-mt-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var grande = mini.getAttribute('data-mt-grande');
          if (!grande) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = grande;
            principal.style.opacity = '1';
          }, 180);
          minis.forEach(function (m) { m.classList.remove('mt-activa'); });
          mini.classList.add('mt-activa');
        });
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariantes() {
    var bloques = document.querySelectorAll('[data-mt-variantes]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var datos = bloque.querySelector('[data-mt-variantes-json]');
      if (!datos) return;

      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var botones = bloque.querySelectorAll('.mt-opcion__valor');
      var inputId = bloque.querySelector('[data-mt-variante-id]');
      var precioEl = bloque.querySelector('[data-mt-precio]');
      var comparaEl = bloque.querySelector('[data-mt-precio-comparado]');
      var botonAnadir = bloque.querySelector('[data-mt-anadir]');
      var textoDisponible = bloque.getAttribute('data-mt-texto-anadir') || 'Anadir al carrito';
      var textoAgotado = bloque.getAttribute('data-mt-texto-agotado') || 'Agotado';

      function seleccionActual() {
        var valores = [];
        bloque.querySelectorAll('[data-mt-opcion-indice]').forEach(function (grupo) {
          var sel = grupo.querySelector('.mt-opcion__valor.mt-sel');
          valores.push(sel ? sel.getAttribute('data-mt-valor') : null);
        });
        return valores;
      }

      function actualizar() {
        var sel = seleccionActual();
        var encontrada = null;
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          var coincide = true;
          for (var j = 0; j < sel.length; j++) {
            if (sel[j] !== null && v.options[j] !== sel[j]) { coincide = false; break; }
          }
          if (coincide) { encontrada = v; break; }
        }
        if (!encontrada) return;

        if (inputId) inputId.value = encontrada.id;
        if (precioEl && encontrada.precio) precioEl.innerHTML = encontrada.precio;
        if (comparaEl) {
          if (encontrada.comparado) {
            comparaEl.innerHTML = encontrada.comparado;
            comparaEl.style.display = '';
          } else {
            comparaEl.style.display = 'none';
          }
        }
        if (botonAnadir) {
          botonAnadir.disabled = !encontrada.available;
          botonAnadir.classList.toggle('mt-agotado', !encontrada.available);
          botonAnadir.textContent = encontrada.available ? textoDisponible : textoAgotado;
        }
      }

      botones.forEach(function (boton) {
        boton.addEventListener('click', function () {
          var grupo = boton.closest('[data-mt-opcion-indice]');
          if (grupo) {
            grupo.querySelectorAll('.mt-opcion__valor').forEach(function (b) { b.classList.remove('mt-sel'); });
          }
          boton.classList.add('mt-sel');
          actualizar();
        });
      });
    });
  }

  /* ---- Barra de compra fija ---- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-mt-sticky]');
    if (!bar) return;
    var referencia = document.querySelector('[data-mt-anadir]') || document.querySelector('.mt-compra form');
    if (!referencia || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          bar.classList.remove('mt-sticky--visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('mt-sticky--visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
    obs.observe(referencia);

    var boton = bar.querySelector('[data-mt-sticky-add]');
    if (boton) {
      boton.addEventListener('click', function () {
        var form = document.getElementById('mt-form-producto');
        if (form) { form.submit(); }
      });
    }
  }

  /* ---- Reseñas: mostrar 5 + pop-up con el resto ---- */
  function initReviewsModal() {
    var root = document.querySelector('[data-mt-reviews]');
    if (!root) return;
    var home = root.querySelector('[data-mt-reviews-home]');
    var openBtn = root.querySelector('[data-mt-reviews-open]');
    var modal = document.querySelector('[data-mt-reviews-modal]');
    if (!home || !openBtn || !modal) return;
    var target = modal.querySelector('[data-mt-reviews-target]');
    var LIMIT = 5;

    function widget() { return document.querySelector('.jdgm-review-widget'); }
    function revs() {
      var w = widget();
      return w ? Array.prototype.slice.call(w.querySelectorAll('.jdgm-rev')) : [];
    }
    function total() {
      var sel = ['.jdgm-rev-widg__summary-total', '.jdgm-prev-badge__text', '.jdgm-preview-badge'];
      for (var i = 0; i < sel.length; i++) {
        var el = document.querySelector(sel[i]);
        if (el) { var m = el.textContent.replace(/[.,]/g, '').match(/(\d+)/); if (m) return parseInt(m[1], 10); }
      }
      return revs().length;
    }
    function hayMas() {
      return total() > LIMIT || !!document.querySelector('[data-mt-reviews-home] .jdgm-paginate a, [data-mt-reviews-home] .jdgm-paginate__page');
    }

    function colapsar() {
      var lista = revs();
      if (!lista.length) return false;
      lista.forEach(function (r, i) { r.classList.toggle('mt-rev-oculta', i >= LIMIT); });
      if (hayMas()) {
        var n = total();
        openBtn.textContent = n > LIMIT ? ('Ver las ' + n + ' reseñas') : 'Ver todas las reseñas';
        openBtn.hidden = false;
      } else {
        openBtn.hidden = true;
      }
      return true;
    }

    function abrir() {
      var w = widget();
      if (!w) return;
      revs().forEach(function (r) { r.classList.remove('mt-rev-oculta'); });
      target.appendChild(w);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function cerrar() {
      var w = widget();
      if (w) home.appendChild(w);
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      colapsar();
    }

    openBtn.addEventListener('click', abrir);
    modal.querySelectorAll('[data-mt-modal-close]').forEach(function (b) {
      b.addEventListener('click', cerrar);
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && !modal.hidden) cerrar();
    });

    // Judge.me carga su widget de forma diferida: reintentar hasta que existan reseñas
    var intentos = 0;
    (function esperar() {
      if (colapsar()) return;
      if (intentos++ > 24) return;
      setTimeout(esperar, 700);
    })();
  }

  function iniciar() {
    initReveal();
    initContadores();
    initFaq();
    initGaleria();
    initVariantes();
    initStickyBuy();
    initReviewsModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor de Shopify recarga secciones sin recargar la pagina
  document.addEventListener('shopify:section:load', iniciar);
})();
